import React from 'react'
import PropTypes from 'prop-types'
import { Calendar, DateObject } from 'react-multi-date-picker'

const CalendarComponent = ({
  mapDays,
  onDateChange,
  viewDate,
  ...restProps
}) => {
  const calendarRef = React.useRef(null)

  const handleYearChange = event => {
    const next = new DateObject({
      year: event.year,
      month: viewDate.month.number,
      day: 1
    })
    onDateChange?.(next)
  }

  const handleMonthChange = event => {
    const next = new DateObject({
      year: event.year,
      month: event.month.number,
      day: 1
    })
    onDateChange?.(next)
  }

  return (
    <Calendar
      ref={calendarRef}
      currentDate={viewDate}
      onYearChange={handleYearChange}
      onMonthChange={handleMonthChange}
      mapDays={mapDays}
      months={[
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ]}
      weekDays={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']}
      {...restProps}
    />
  )
}

CalendarComponent.propTypes = {
  mapDays: PropTypes.func.isRequired,
  viewDate: PropTypes.object.isRequired,
  onDateChange: PropTypes.func
}

export default CalendarComponent
